/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MEMBER" | "MODERATOR" | "STAFF" | "%future added value";
export type TabBarContainer_viewer = {
    readonly id: string;
    readonly role: USER_ROLE;
    readonly inPageNotifications: {
        readonly enabled: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"useLiveNotificationsPolling_viewer">;
    readonly " $refType": "TabBarContainer_viewer";
};
export type TabBarContainer_viewer$data = TabBarContainer_viewer;
export type TabBarContainer_viewer$key = {
    readonly " $data"?: TabBarContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"TabBarContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TabBarContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "UserInPageNotificationSettings",
            "kind": "LinkedField",
            "name": "inPageNotifications",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useLiveNotificationsPolling_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '3ecb51611d55bc7e0b9a0ffc052c8974';
export default node;
